<template>
    <div class="soft-update">
        <!--顶部介绍-->
        <picture>
            <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
            <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
            <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
        </picture>
        <breadcrumb :guide="guide"></breadcrumb>
        <!--主体内容-->
        <div class="x-container">
            <!-- <div class="changePageButtonContainer">
                <div class="changePageButton">
                    <span @click="changePage('record')" class="pageBtn"
                        :class="{ 'active': active === 'record' }">请求记录</span>
                    <span @click="changePage('sign')" class="pageBtn"
                        :class="{ 'active': active === 'sign' }">签审管理</span>
                </div>
            </div>
            <RequestRecord v-if="active === 'record'" />
            <SignOffManagement v-if="active === 'sign'" /> -->
            <SignOffManagement v-if="active === 'sign'" />
        </div>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb';
import RequestRecord from './RequestRecord.vue';
import SignOffManagement from './SignOffManagement.vue';
import { mapGetters, mapActions } from "vuex";
import { needLogin, hasAuthority } from "@/utils/needLoginList";
import { shakeMessage } from "@/utils/shakeMsg";
import qs from "qs";
export default {
    name: "softUpdate",
    components: {
        breadcrumb,
        RequestRecord,
        SignOffManagement,
    },
    computed: {
        ...mapGetters(['getUserName']),
    },
    data() {
        return {
            guide: [
                { label: '服务与支持' },
                { label: '软件更新' },
            ],
            active: "sign",
        }
    },
    methods: {
        async changePage(active) {
            this.active = active;
        },
    },
    mounted() {

    },
    destroyed() {

    },
}
</script>

<style scoped lang="less">
/*头部背景图*/
.bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}
</style>
<style lang="less" scoped>
.box-card {
    text-align: left;
    margin-top: 1.25rem;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-sizing: border-box;
    padding: 1.25rem;
    font-size: 1rem;
    width: 80%;
    margin: 0 auto;
}

.box-card:nth-child(n + 2) {
    margin-top: 1.25rem;
}

@media only screen and (max-width: 797px) {
    .image-div {
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .soft-detail-div {
        width: 100%;
    }

    /deep/ .download-btn {
        .el-button {
            font-weight: bold;
        }
    }
}

@media only screen and (min-width: 798px) {
    .image-div {
        width: 46%;
    }

    .soft-detail-div {
        width: 50%;
    }
}

.x-container {
    color: #333333;
    padding-top: 0;
    @media (min-width: 1200px) {
        width: 1600px !important;
    }
}

.changePageButtonContainer {
    text-align: left;
    // padding-left: 80px;
    margin-left: -20px;
}

.changePageButton {
    display: inline-block;
    font-size: 18px;
    margin-bottom: 28px;
    position: relative;
    text-align: center;

    .pageBtn {
        display: inline-block;
        background-color: #d2e6ff;
        color: #808080;
        padding: 7px 14px;
        cursor: pointer;

        &.active {
            background-color: #3399ff;
            color: #ffffff;
            font-weight: bold;
        }

        &:first-child {
            box-shadow: 1px 2px 6px 0px #808080;
            border-top-left-radius: 32px;
            border-bottom-left-radius: 32px;
            padding-left: 20px;
        }

        &:last-child {
            box-shadow: 1px 2px 6px 0px #808080;
            border-top-right-radius: 32px;
            border-bottom-right-radius: 32px;
            padding-right: 20px;
        }

    }

    .point {
        height: 12px;
        width: 12px;
        background-color: #2c53b0;
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
    }
}

.title {
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.soft-img {
    width: 100%;
    aspect-ratio: 1.88;
}

.bottom {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.description {
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
    color: #666666;
}

.soft-value {
    color: #4d4d4d;
    font-size: 0.8rem;
}

.soft-label {
    font-size: 0.7rem;
    color: #808080;
}

.update-record {
    margin-top: 0.5rem;
    font-size: 0.7rem;
    color: #666666;
}

.record-item {
    margin-top: 5px;
}

.download-btn {
    text-align: center;
    margin-top: 0.5rem
}

/deep/ .el-divider--vertical {
    margin: 0 0.3rem;
    height: 2.2em;
}

/deep/ .download-btn {
    .el-button {
        padding: 0.5rem;
        font-size: 0.8rem;
        background: linear-gradient(to right, #158cff, #29abe2);
    }
}
</style>
